<template>
  <div class="banner-2" v-if="!loading" :style="boxStyle">
    <div class="body" v-html="data.body"></div>
    <div class="image"><img :src="data.image"></div>
    <div class="more text-center">
      <router-link :to="{name: 'map'}" class="btn btn-purple-1 font-bold font-size-m">Ver mapa</router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      data: {},
      boxStyle: {}
    }
  },

  methods: {
    load(){
      this.loading = true;
      this.$api.get('/v1/banner_2')
        .then(({body}) => {
          this.data = body.rows[0];
          this.boxStyle['background-image'] = `url(${this.data.bg})`;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  created(){
    this.load();
  }
}
</script>

<style lang="scss" scoped>
.banner-2
{
  padding: 30px 15px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>